import { getCurrentUser, loginApi, requestOtp } from '@/features/auth';
import type { LoginRequest } from '@/features/auth/models/auth-login';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useLogin = () => {
  const queryClient = useQueryClient();
  const { setAuth, clearAuth } = useAuthStore();
  return useMutation({
    mutationFn: async (req: LoginRequest) => {
      await requestOtp(req.username);
      return await loginApi(req);
    },
    onSuccess: async (data) => {
      if (data?.accessToken) {
        const userMe = await getCurrentUser(data.accessToken);
        setAuth({
          user: {
            user_id: userMe.id
          },
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          expiredAt: data.expiredAt
        });
        queryClient.invalidateQueries();
      }
    },
    onError: (error) => {
      console.error('Login failed:', error);
      clearAuth();
    }
  });
};
